import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const footerArticles = [
  { slug: 'kakobuy-spreadsheet-polski-przewodnik', label: 'Przewodnik' },
  { slug: 'bezpieczenstwo-kakobuy-poradnik', label: 'Bezpieczeństwo' },
  { slug: 'poradnik-zakupowy-kakobuy', label: 'Poradnik zakupowy' },
  { slug: 'porownanie-produktow-kakobuy', label: 'Porównanie produktów' },
  { slug: 'najlepsze-sneakers-kakobuy-spreadsheet', label: 'Najlepsze sneakersy' },
  { slug: 'kakobuy-dla-poczatkujacych-poradnik', label: 'Dla początkujących' },
  { slug: 'kakobuy-spreadsheet-2026-ranking', label: 'Ranking 2026' },
  { slug: 'ukryte-produkty-kakobuy', label: 'Ukryte produkty' },
];

export default function Footer() {
  return (
    <footer className="bg-background-100/80 border-t border-background-200/70">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-file-list-3-line text-lg text-background-50"></i>
              </div>
              <span className="font-semibold text-sm text-foreground-950">
                Kakobuy Spreadsheet Polska
              </span>
            </div>
            <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-4">
              Niezależny przewodnik po produktach Kakobuy dla użytkowników z Polski. Znajdź najlepsze okazje i oszczędź czas.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3">Poradniki</h4>
            <ul className="space-y-2">
              {footerArticles.slice(0, 4).map((a) => (
                <li key={a.slug}>
                  <Link to={`/artykul/${a.slug}`} className="text-xs md:text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    {a.label}
                  </Link>
                </li>
              ))}
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs md:text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  Kakobuy Spreadsheet
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3">Artykuły</h4>
            <ul className="space-y-2">
              {footerArticles.slice(4, 8).map((a) => (
                <li key={a.slug}>
                  <Link to={`/artykul/${a.slug}`} className="text-xs md:text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    {a.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3">Kategorie</h4>
            <ul className="space-y-2">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-xs text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {cat.namePl}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              © 2026 Kakobuy Spreadsheet Polska. Wszelkie prawa zastrzeżone.
            </p>
            <p className="text-xs text-foreground-500 text-center">
              Ta strona jest niezależnym przewodnikiem. Wszystkie linki zewnętrzne otwierają się w nowej karcie.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}